import { hasAdminRole } from "./jwt.helper";
import { TokenService } from "../_services/token.service";
import { inject } from "@angular/core";
import { Router, CanActivateFn } from "@angular/router";

export const adminGuard: CanActivateFn = (route, state) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);
  const token = tokenService.getToken();

  if (hasAdminRole(token)) {
    return true;
  }

  localStorage.setItem('redirectUrl', state.url);
  router.navigateByUrl('/');
  return false;
};
